import constants   from 'misa:constants';
  
export const MSConstant = constants;
 